import { createReducer, on } from '@ngrx/store';
import * as PermissionsActions from './permissions.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {PermissionsTarget} from "./permissions.facade";

export const permissionsFeatureKey = 'permissions';

export interface TargetPermissions {
  target: PermissionsTarget;
  permissions: string[];
}

export interface PermissionsState extends EntityState<TargetPermissions> {
  loadingTarget: string | null; // Key of the target being loaded
  error: any | null;
}

export const permissionsAdapter: EntityAdapter<TargetPermissions> = createEntityAdapter<
  TargetPermissions
>({ selectId: (e) => e.target });

export const permissionsInitialState = permissionsAdapter.getInitialState({
  loadingTarget: null,
  error: null,
});
export const reducer = createReducer(
  permissionsInitialState,

  on(PermissionsActions.getTargetPermissions, (state, { payload }) => ({
    ...state,
    loadingTargetPermissions: payload,
    error: null,
  })),
  on(
    PermissionsActions.getTargetPermissionsSuccess,
    (state, { payload, target }) => {
      const data = { target, permissions: payload };
      return permissionsAdapter.upsertOne(
        data,
        {
          ids: state.ids || [],
          ...state,
          loadingTarget: null,
        }
      );
    }
  ),
  on(PermissionsActions.getTargetPermissionsFailure, (state, { error }) => {
    return { ...state, loadingTarget: null, error };
  })
);
